exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rightBorderSeparator{border-right-width:4px;border-right-color:#ffcc02;border-right-style:solid}", ""]);

// exports
